import { TaskListDto } from '@/api/generated/model';
import DashboardGrid from '@/components/dashboard/dashboard-grid/dashboard-grid';
import { Box } from '@cmpsr/components';

import DashboardLayout from '@/components/dashboard/dashboard-layout/dashboard-layout';
import DashboardHeaderActionsCard from './components/dashboard-header-actions-card/dashboard-header-actions-card';
import { ChartSeriesData } from './components/dashboard-header-summary-card/components/dashboard-header-chart/dashboard-header-chart';
import DashboardHeaderSummaryCard from './components/dashboard-header-summary-card/dashboard-header-summary-card';
import DashboardHeaderTitle from './components/dashboard-header-title/dashboard-header-title';

type DashboardHeaderProps = {
  name?: string;
  currentRisk: number;
  averageRisk: number;
  potentialRisk: number;
  averageRiskPercentage: number;
  tasks?: TaskListDto['data'];
  series: ChartSeriesData[];
};

export default function DashboardHeader(props: DashboardHeaderProps) {
  return (
    <DashboardLayout
      containerProps={{
        // Theses custom paddings are to have the main title
        // and subtitle at the same level in every page
        pt: { base: 14, md: 14, lg: 16 },
        pb: { base: 8, md: 10, lg: 14 },
        background: 'gradient.dark',
      }}
      contentProps={{ as: 'header', gap: 5 }}
    >
      <DashboardHeaderTitle name={props.name} />
      <DashboardGrid>
        <DashboardHeaderSummaryCard
          currentRisk={props.currentRisk}
          averageRisk={props.averageRisk}
          potentialRisk={props.potentialRisk}
          averageRiskPercentage={props.averageRiskPercentage}
          series={props.series}
        />
        <Box minW="full">
          <DashboardHeaderActionsCard tasks={props.tasks} />
        </Box>
      </DashboardGrid>
    </DashboardLayout>
  );
}
